import React from 'react'
import {makeStyles} from '@mui/styles';
import TextField from '@mui/material/TextField';
import {Box, Button, IconButton, Tooltip} from '@mui/material';
import Creatable from "react-select/creatable";
import makeAnimated from 'react-select/animated'
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import {useSelector} from "react-redux";
import Typography from "@mui/material/Typography";
import {Help} from "@mui/icons-material";

const useStyles = makeStyles(theme => ({
    card: {
        width: '70vw',
        minWidth: '100px',
        borderRadius: 20,

    },
    CardContent: {
        display: 'flex',
        flexDirection: "column",
        padding: '10%',
    },
    button: {
        pointerEvents: "none",
    },
    inputTitle: {
        marginTop: "15px",
        alignItems: "center",
    },
    ingEdit:{
        overflowY: "visible",
        "& .MuiPaper-root": {
            overflowY: "visible",
        },
    },
    alert:{
        color:"red"
    }

}));
const animatedComponents = makeAnimated();


export default function IngredientVerifier({
                                               open,
                                               editingIngredient,
                                               selectedIngredient,
                                               ingredientOptions,
                                               loading,
                                               addIngredientToRecipe,
                                               closeDialog,
                                               createNewIngredient,
                                               setSelectedIngredient,
                                               setQty,
                                               setQtyType,
                                               searchIngredients
                                           }) {

    const qtyTypes = useSelector(state => state.global.qtyTypes)
    const {qty, qtyType, ingredientName} = editingIngredient

    const classes = useStyles();
    console.log(editingIngredient)
    return (
        <Dialog
            open={open}
            className={classes.ingEdit}
            onClose={closeDialog}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle id="scroll-dialog-title">{ingredientName ? ingredientName : "Ingredient Add"}</DialogTitle>
            <DialogContent dividers={true} className={classes.ingEdit}>
                <Box display={"flex"} style={{alignItems: "center"}}>
                    <Typography variant={"subtitle1"} className={classes.inputTitle}>Ingredient:</Typography>
                    <Tooltip enterTouchDelay={0} title={
                        <React.Fragment>
                            <Typography variant={"subtitle2"} className={classes.subTitle}>
                                Search through all our verified ingredients. <br/>
                                If you need to add a new ingredient we have not seen before,
                                you can create it here, and we will verify it as soon as possible!
                            </Typography>
                        </React.Fragment>
                    }>
                        <IconButton>
                            <Help/>
                        </IconButton>
                    </Tooltip>
                </Box>
                {selectedIngredient?.value?.isNew && (
                    <Typography variant="caption" className={classes.alert}>
                        No ingredient found. We'll create a new one for you.
                    </Typography>
                )}
                <Creatable
                           closeMenuOnSelect={true}
                           components={animatedComponents}
                           value={selectedIngredient}
                           isLoading={loading}
                           onCreateOption={createNewIngredient}
                           onInputChange={searchIngredients}
                           options={ingredientOptions}
                           onChange={(x) => setSelectedIngredient(x.value)}
                />
                <Box display={"flex"} style={{alignItems: "center"}}>
                <Typography variant={"subtitle1"} className={classes.inputTitle}>Quantity:</Typography>
                <Tooltip enterTouchDelay={0} title={
                    <React.Fragment>
                        <Typography variant={"subtitle2"} className={classes.subTitle}>
                            Enter the quantity, and select the type that best suits your item.
                            Don't worry we should be able to help users convert between most
                            types after you have selected!
                        </Typography>
                    </React.Fragment>
                }>
                    <IconButton>
                        <Help/>
                    </IconButton>
                </Tooltip>
                </Box>
                <Box display={"flex"} style={{alignItems: "center"}}>
                    <div className={classes.qty}>
                        <TextField defaultValue={qty}
                                   onChange={setQty}
                        />
                    </div>
                    {(<Select
                        className={classes.qtyType}
                        defaultValue={qtyType ? qtyType : "ABSOLOUTE"}
                        onChange={setQtyType}
                        inputProps={{'aria-label': 'Without label'}}
                    >
                        {Object.entries(qtyTypes).map(([key, nice]) => (
                            <MenuItem key={key} value={key}>
                                {nice}
                            </MenuItem>
                        ))}
                    </Select>)}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={selectedIngredient?.value?.isNew
                        ? () => createNewIngredient(selectedIngredient.value.name)
                        : addIngredientToRecipe}
                    color="primary"
                >
                    {selectedIngredient?.value?.isNew ? "Create" : "Confirm"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}